import { all, call, takeLatest } from "redux-saga/effects";
import { removeStorage, setStorage } from "utils/useLocalStorage";
import { CompanyActions } from "./company.interface";
import { Action } from "./company.reducer";

function* load(action:Action):any{
  let company = action.payload.company;
  try {
    if(company.cleanable){
      yield call(setStorage,"company_access",company);
    }
  } catch (error) {
    console.error(error);
  }
}

function* clearCompany():any{
  try {
    yield call(removeStorage,"company_access");
  } catch (error) {
    console.error(error);
  }
}

export default function* root():any{
  return yield all([
    takeLatest(CompanyActions.SET_COMPANY, load),
    takeLatest(CompanyActions.CLEAR_COMPANY, clearCompany),
  ]);
}